"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _luxon = require("luxon");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _breakpoints = require("../../constants/breakpoints");

var _colors = require("../../constants/colors");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _colors2 = require("./colors");

var _Styles = require("./Styles");

var _chartStyles = require("./chartStyles");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  width: 200px;\n"])));

var ChartWrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 400px;\n  width: 200px;\n  @media only screen and (max-width: ", ") {\n    height: 300px;\n  }\n"])), _colors.GREY_HOVER, _breakpoints.MAX_DESKTOP_BREAKPOINT);

var MonthHeader = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: 10px 0;\n  text-align: center;\n"])), _colors.DARK_GREY, _colors.WHITE);

var StyledHint = (0, _styled["default"])(_reactVis.Hint)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  z-index: 1;\n"])));

var getDateRange = function getDateRange(beginningDate, lastDayOfMonth) {
  switch (beginningDate) {
    case '1':
      return '1-7';

    case '8':
      return '8-14';

    case '15':
      return '15-21';

    case '22':
      return "22-".concat(lastDayOfMonth);

    default:
      return '';
  }
};

var getCurrentMonth = function getCurrentMonth(week, timeZone, today) {
  var month = _luxon.DateTime.fromISO(week, {
    zone: timeZone
  }).toFormat('L-y');

  var currentMonth = _luxon.DateTime.fromISO(today, {
    zone: timeZone
  }).toFormat('L-y');

  return month === currentMonth;
};

var getCurrentWeek = function getCurrentWeek(week, lastDayOfMonth, timeZone) {
  var weekDay = _luxon.DateTime.fromISO(week, {
    zone: timeZone
  }).toFormat('d');

  var weeks = [[1, 7], [8, 14], [15, 21], [22, Number(lastDayOfMonth)]];
  return weeks.find(function (i) {
    return i[0] === Number(weekDay);
  });
};

var isCurrentWeekOrFutureWeek = function isCurrentWeekOrFutureWeek(week, today, lastDayOfMonth, timeZone) {
  var currentWeek = getCurrentWeek(week, lastDayOfMonth, timeZone);
  var isCurrentMonth = getCurrentMonth(week, timeZone, today);

  var todayNumber = _luxon.DateTime.fromISO(today, {
    zone: timeZone
  }).toFormat('d');

  return isCurrentMonth && (todayNumber <= currentWeek[0] || todayNumber < currentWeek[1]);
};

var isMiddleOfCurrentWeek = function isMiddleOfCurrentWeek(week, today, lastDayOfMonth, timeZone) {
  var currentWeek = getCurrentWeek(week, lastDayOfMonth, timeZone);
  var isCurrentMonth = getCurrentMonth(week, timeZone, today);

  var todayNumber = _luxon.DateTime.fromISO(today, {
    zone: timeZone
  }).toFormat('d');

  return isCurrentMonth && todayNumber >= currentWeek[0] && todayNumber <= currentWeek[1];
};

var MonthByWeekChart = function MonthByWeekChart(_ref) {
  var ptoDateISO = _ref.ptoDateISO,
      renderHint = _ref.renderHint,
      roundedMaxValue = _ref.roundedMaxValue,
      siteProductionWeeklyReadings = _ref.siteProductionWeeklyReadings,
      timeZone = _ref.timeZone;

  var ptoDateTime = _luxon.DateTime.fromISO(ptoDateISO, {
    zone: timeZone
  });

  var readingDictionary = siteProductionWeeklyReadings.reduce(function (dictionary, coordinate) {
    dictionary[coordinate.x] = coordinate.y;
    return dictionary;
  }, {});

  var luxonTodaysDate = _luxon.DateTime.local().setZone(timeZone);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCoordinate = _useState2[0],
      setSelectedCoordinate = _useState2[1];

  var lastDayOfMonth = _luxon.DateTime.fromISO(siteProductionWeeklyReadings[0].x, {
    zone: timeZone
  }).endOf('month').toFormat('d');

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, {
    onMouseLeave: function onMouseLeave() {
      return setSelectedCoordinate(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(MonthHeader, null, _luxon.DateTime.fromISO(siteProductionWeeklyReadings[0].x, {
    zone: timeZone
  }).toFormat('LLLL')), /*#__PURE__*/_react["default"].createElement(ChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    margin: {
      left: 0,
      right: 0,
      bottom: 60,
      top: 60
    },
    xType: "ordinal",
    yDomain: [0, roundedMaxValue],
    onClick: function onClick() {
      setSelectedCoordinate(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalBarSeries, {
    barWidth: 0.4,
    timeZone: timeZone,
    lastDayOfMonth: lastDayOfMonth,
    isCurrentWeekOrFutureWeek: isCurrentWeekOrFutureWeek,
    colorType: "literal",
    getColor: function getColor(c) {
      if (_luxon.DateTime.fromISO(c.x, {
        zone: timeZone
      }) < ptoDateTime) {
        return _colors2.BEFORE_PTO_COLOR;
      }

      if (selectedCoordinate && selectedCoordinate.x === c.x) {
        return _colors2.IMPORTANT_COLOR;
      }

      if (selectedCoordinate && selectedCoordinate.x !== c.x) {
        return _colors2.IMPORTANT_COLOR_OPAQUE;
      }

      if (c.y === 0) {
        return _colors2.IMPORTANT_COLOR_OPAQUE;
      }

      return _colors2.IMPORTANT_COLOR;
    },
    data: siteProductionWeeklyReadings,
    onValueClick: function onValueClick(c, e) {
      setSelectedCoordinate(c);
      e.event.stopPropagation();
    },
    style: {
      cursor: 'pointer'
    }
  }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(StyledHint, {
    marginTop: -10,
    marginLeft: -79,
    marginRight: -79,
    value: selectedCoordinate
  }, /*#__PURE__*/_react["default"].createElement(_Styles.HintBox, null, /*#__PURE__*/_react["default"].createElement(_Styles.HintHeader, {
    color: isCurrentWeekOrFutureWeek(selectedCoordinate.x, luxonTodaysDate, lastDayOfMonth, timeZone) ? _colors2.GRAYED_OUT_COLOR : ''
  }, _luxon.DateTime.fromISO(selectedCoordinate.x, {
    zone: timeZone
  }).toFormat('LLLL'), "\xA0", getDateRange(_luxon.DateTime.fromISO(selectedCoordinate.x, {
    zone: timeZone
  }).toFormat('d'), lastDayOfMonth)), /*#__PURE__*/_react["default"].createElement(_Styles.HintBody, null, renderHint && renderHint(readingDictionary[selectedCoordinate.x]), isMiddleOfCurrentWeek(selectedCoordinate.x, luxonTodaysDate, lastDayOfMonth, timeZone) && /*#__PURE__*/_react["default"].createElement("p", null, "This week's not over yet!")))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _chartStyles.borderStyle
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    style: _chartStyles.xAxisStyle,
    tickFormat: function tickFormat(isoDate) {
      return getDateRange(_luxon.DateTime.fromISO(isoDate, {
        zone: timeZone
      }).toFormat('d'), lastDayOfMonth);
    }
  })))));
};

MonthByWeekChart.propTypes = {
  ptoDateISO: _propTypes["default"].string.isRequired,
  renderHint: _propTypes["default"].func,
  roundedMaxValue: _propTypes["default"].number.isRequired,
  siteProductionWeeklyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].string,
    y: _propTypes["default"].number,
    y0: _propTypes["default"].number
  })),
  timeZone: _propTypes["default"].string.isRequired
};
MonthByWeekChart.defaultProps = {
  siteProductionWeeklyReadings: [],
  renderHint: undefined
};
var _default = MonthByWeekChart;
exports["default"] = _default;